import React, { useState } from 'react';

// Emoji flags do not render on Windows (they fall back to letter pairs like "PT"),
// so we render real flag images and only fall back to the emoji if the image fails.
const LANGUAGE_COUNTRY = {
  pt: 'pt',
  en: 'gb',
  es: 'es',
  fr: 'fr',
  de: 'de',
  it: 'it'
};

export const Flag = ({ code, emoji, className = '', size = 20 }) => {
  const [failed, setFailed] = useState(false);
  const iso = (code || '').toLowerCase();

  if (!iso || iso === 'other' || failed) {
    return (
      <span className={`inline-block leading-none ${className}`} style={{ fontSize: size * 0.85 }}>
        {emoji || '🌍'}
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/w40/${iso}.png`}
      srcSet={`https://flagcdn.com/w80/${iso}.png 2x`}
      width={size}
      height={Math.round(size * 0.75)}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
      className={`inline-block rounded-[2px] object-cover flex-shrink-0 ${className}`}
      style={{ width: size, height: Math.round(size * 0.75) }}
    />
  );
};

export const LanguageFlag = ({ language, emoji, className = '', size = 20 }) => (
  <Flag code={LANGUAGE_COUNTRY[language]} emoji={emoji} className={className} size={size} />
);

export default Flag;
